/* SETTINGS */
export var CHANGE_LOCALE = 'CHANGE_LOCALE';
/* AUTH */
export var LOGIN_USER = 'LOGIN_USER';
export var LOGIN_USER_WITH_COMPLETE_NEW_PASSWORD = 'LOGIN_USER_WITH_COMPLETE_NEW_PASSWORD';
export var LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export var LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export var LOGIN_GOOGLE_USER = 'LOGIN_GOOGLE_USER';
export var CURRENT_AUTHENTICATED_USER = 'CURRENT_AUTHENTICATED_USER';
export var CURRENT_AUTHENTICATED_USER_SUCCESS = 'CURRENT_AUTHENTICATED_USER_SUCCESS';
export var CURRENT_AUTHENTICATED_USER_ERROR = 'CURRENT_AUTHENTICATED_USER_ERROR';
// export const REGISTER_USER = 'REGISTER_USER';
// export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
// export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
// export const CONFIRM_REGISTER_USER = 'CONFIRM_REGISTER_USER';
// export const CONFIRM_REGISTER_USER_SUCCESS = 'CONFIRM_REGISTER_USER_SUCCESS';
// export const CONFIRM_REGISTER_USER_ERROR = 'CONFIRM_REGISTER_USER_ERROR';
export var LOGOUT_USER = 'LOGOUT_USER';
export var FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export var FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export var FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export var NEW_PASSWORD = 'NEW_PASSWORD';
export var NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS';
export var NEW_PASSWORD_ERROR = 'NEW_PASSWORD_ERROR';
export var COMPLETE_NEW_PASSWORD = 'COMPLETE_NEW_PASSWORD';
export var COMPLETE_NEW_PASSWORD_SUCCESS = 'COMPLETE_NEW_PASSWORD_SUCCESS';
export var COMPLETE_NEW_PASSWORD_ERROR = 'COMPLETE_NEW_PASSWORD_ERROR';
/* USER */
export var USER_INFO = 'USER_INFO';
export var USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export var USER_INFO_ERROR = 'USER_INFO_ERROR';
export var SET_USER = 'SET_USER';
export var SET_HOLDER = 'SET_HOLDER';
export var SET_PLANS = 'SET_PLANS';
export var SET_ORGANIZATION = 'SET_ORGANIZATION';
export var SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export var SET_TOTAL_NOTIFICATIONS = 'SET_TOTAL_NOTIFICATIONS';
export var SET_SETTINGS_NOTIFICATIONS = 'SET_SETTINGS_NOTIFICATIONS';
export var SET_USER_LOADING = 'SET_USER_LOADING';
/* MENU */
export var MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export var MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export var MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export var MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export var MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';
export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './user/actions';
